const Payment = () =>
  import(
    /* webpackChunkName: "system-gateway-payment" */ '@/pages/system/gateway/payment/index.vue'
  )
const CreatePayment = () =>
  import(
    /* webpackChunkName: "system-gateway-payment" */ '@/pages/system/gateway/payment/create.vue'
  )
const EditPayment = () =>
  import(
    /* webpackChunkName: "system-gateway-payment" */ '@/pages/system/gateway/payment/edit.vue'
  )

export default {
  path: 'payment',
  meta: {
    label: 'payment',
    auth: 'payment'
  },
  component: {
    name: 'Payment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: '',
      name: 'SystemGatewayPayment',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Payment
    },
    {
      name: 'SystemCreateGatewayPayment',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreatePayment
    },
    {
      name: 'SystemEditGatewayPayment',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditPayment,
      props: true
    }
  ]
}
